import { Component } from '@angular/core';

@Component({
  selector: 'app-legal',
  templateUrl: './legal.component.html',
  styles: [
    `
      .legal-wrapper {
        padding-bottom: 60px;
      }
    `,
  ],
})
export class LegalComponent {}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/_v2/legal/legal.component.ts